import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Countdown = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	color: theme.palette.primary.contrastText,
	fontVariantNumeric: 'tabular-nums',
}));
